// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KBqx","title":"styles_title__pAmJK"};